export default __webpack_public_path__ + "static/media/Kia.204f969f.jpg";